import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import config from 'utils/config';
import { renderMindsetSDK2 } from './render/renderMindsetSDK2';
import { renderMindsetSDK3 } from './render/renderMindsetSDK3';
import { MINDSET_SDK2_URL, MINDSET_SDK3_URL } from './render/mindsetSdkUrls';
import { domPrefetchScript } from './render/domPrefetchScript';
import { fetchCachedMindsetSettings } from './fetchCachedMindsetSettings';
import { serializeRenderCalls } from './serializeRenderCalls';
import { getAgentElement, MINDSET_CARD_ID } from './getAgentElement';
import { whenAgentIdle } from './whenAgentIdle';
function renderMindsetCardAgent(_x) {
  return _renderMindsetCardAgent.apply(this, arguments);
}
function _renderMindsetCardAgent() {
  _renderMindsetCardAgent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var initialQuestion, forceOnboardingPlan, _ref$silent, silent, appUid, hasMindsetSDK2, _yield$fetchCachedMin, agentUid, agentEl;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          initialQuestion = _ref.initialQuestion, forceOnboardingPlan = _ref.forceOnboardingPlan, _ref$silent = _ref.silent, silent = _ref$silent === void 0 ? false : _ref$silent;
          appUid = config.mindsetAppUid, hasMindsetSDK2 = config.hasMindsetSDK2;
          if (appUid) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return");
        case 1:
          _context.next = 2;
          return fetchCachedMindsetSettings(forceOnboardingPlan);
        case 2:
          _yield$fetchCachedMin = _context.sent;
          agentUid = _yield$fetchCachedMin.agentUid;
          if (agentUid) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          if (!hasMindsetSDK2) {
            _context.next = 5;
            break;
          }
          _context.next = 4;
          return renderMindsetSDK2({
            scriptURL: MINDSET_SDK2_URL,
            appUid: appUid,
            initialQuestion: initialQuestion,
            agentUid: agentUid
          });
        case 4:
          return _context.abrupt("return");
        case 5:
          _context.next = 6;
          return renderMindsetSDK3({
            appUid: appUid,
            agentUid: agentUid,
            initialQuestion: silent ? '' : initialQuestion
          });
        case 6:
          if (silent && initialQuestion) {
            agentEl = getAgentElement(MINDSET_CARD_ID);
            whenAgentIdle(agentEl, function () {
              var _agentEl$sendMessage;
              agentEl === null || agentEl === void 0 || (_agentEl$sendMessage = agentEl.sendMessage) === null || _agentEl$sendMessage === void 0 || _agentEl$sendMessage.call(agentEl, initialQuestion, {
                silent: true
              });
            });
          }
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _renderMindsetCardAgent.apply(this, arguments);
}
var renderMindsetCardAgentSerialized = serializeRenderCalls(renderMindsetCardAgent);
export function addMindsetCardAgentIfRequired() {
  return _addMindsetCardAgentIfRequired.apply(this, arguments);
}
function _addMindsetCardAgentIfRequired() {
  _addMindsetCardAgentIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ref2,
      _ref2$render,
      render,
      _ref2$search,
      initialQuestion,
      forceOnboardingPlan,
      _ref2$silent,
      silent,
      appUid,
      hasMindsetSDK2,
      _yield$fetchCachedMin2,
      agentUid,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref2$render = _ref2.render, render = _ref2$render === void 0 ? false : _ref2$render, _ref2$search = _ref2.search, initialQuestion = _ref2$search === void 0 ? '' : _ref2$search, forceOnboardingPlan = _ref2.forceOnboardingPlan, _ref2$silent = _ref2.silent, silent = _ref2$silent === void 0 ? false : _ref2$silent;
          appUid = config.mindsetAppUid, hasMindsetSDK2 = config.hasMindsetSDK2;
          if (appUid) {
            _context2.next = 1;
            break;
          }
          return _context2.abrupt("return");
        case 1:
          if (render) {
            _context2.next = 4;
            break;
          }
          _context2.next = 2;
          return fetchCachedMindsetSettings(forceOnboardingPlan);
        case 2:
          _yield$fetchCachedMin2 = _context2.sent;
          agentUid = _yield$fetchCachedMin2.agentUid;
          if (agentUid) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          domPrefetchScript(hasMindsetSDK2 ? MINDSET_SDK2_URL : MINDSET_SDK3_URL);
          return _context2.abrupt("return");
        case 4:
          return _context2.abrupt("return", renderMindsetCardAgentSerialized({
            initialQuestion: initialQuestion,
            forceOnboardingPlan: forceOnboardingPlan,
            silent: silent
          }));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _addMindsetCardAgentIfRequired.apply(this, arguments);
}